import { render, staticRenderFns } from "./NotStartScript.vue?vue&type=template&id=c1e1db9a&scoped=true"
import script from "./NotStartScript.vue?vue&type=script&lang=js"
export * from "./NotStartScript.vue?vue&type=script&lang=js"
import style0 from "./NotStartScript.vue?vue&type=style&index=0&id=c1e1db9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e1db9a",
  null
  
)

export default component.exports